import { PerformanceCategoriesSupport, QuestionSupport, ProgramRole } from '@app/shared/enums';
import {
  PeFormInstanceWorkflowHistoryRecordApiModel,
  PeFormInstancePerformanceCategoryApiModel,
  PeFormInstanceQuestionApiModel,
  PeFormInstanceQuestionHeadingApiModel
} from './../pe-features';
import { PeFormResponseType } from '@app/shared/enums/pe-form-response-type.enum';
import { FormAction } from '@app/shared/enums/form-action.enum';
import { PpBoundFormInstanceApiModel } from '@app/api/api-models/pp-form-instance/PpBoundFormInstanceApiModel';
import { UserListApiModel } from '../users/UserListApiModel';
import { FormInstancePerformanceCategoryBaseApiModel } from '../program/shared/form-instances/FormInstancePerformanceCategoryBaseApiModel';
import { ProgramExitTypeNature } from '@app/shared/enums/program-exit-type-nature.enum';
import { FormInstanceRatingApiModel } from '../program/shared/form-instances/FormInstanceRatingApiModel';

export class PpFormInstanceApiModel {
  public Id: number;
  public Name: string;
  public FormId: number;
  public PerformanceCategoriesSupport: PerformanceCategoriesSupport;
  public QuestionSupport: QuestionSupport;
  public FormAction: FormAction;
  public ProgramExitTypeId: number;
  public ProgramExitTypeName: string;
  public ProgramExitTypeNature: ProgramExitTypeNature;
  public CurrentComment: string;
  public CurrentStepId: number;
  public CurrentStepName: string;
  public CurrentStepResponseType: PeFormResponseType;
  public ShiftId: number | null;
  public ShiftName: string;
  public LocationId: number | null;
  public LocationName: string;
  public CreatorNarrative: string;
  public SubjectNarrative: string;
  public HasCreatorNarrative: boolean;
  public HasSubjectNarrative: boolean;
  public DisplayRelatedPerformanceData: boolean;
  public DisplayHistoryToSubject: boolean;
  public DisplayCategoryAverage: boolean;
  public MinDate: Date;
  public MaxDate: Date;
  public MinWorkDate: Date;
  public MaxWorkDate: Date;
  public ActualMinDate: string;
  public ActualMaxDate: string;
  public WorkDate: Date;
  public ActualWorkDate: string;
  public SubjectUserId: string;
  public CreatorUserId: string;
  public SubjectFullName: string;
  public CreatorFullName: string;
  public SubjectAvatarSrc: string;
  public SubjectRole: ProgramRole;
  public SubjectProgramRoleId: string;
  public SubjectJobTitleName: string;
  public SubjectIdNumber: string;
  public CreatorProgramRoleId: string;
  public IsEditable: boolean;
  public IsHeaderEditable: boolean;
  public IsDeletable: boolean;
  public IsSubmitted: boolean;
  public IsActionable: boolean;
  public IsCritique: boolean;
  public IsSummary: boolean;
  public IsRejected: boolean;
  public IsRejectable: boolean;
  public InstanceNumber: string;
  public HasSummarySupportingDocuments: boolean;
  public HasCitizenFeedback: boolean;
  public ForbiddenInstanceNumbers: Array<string>;
  public NextUsers: Array<UserListApiModel>;
  public PerformanceCategories: Array<FormInstancePerformanceCategoryBaseApiModel>;
  public Questions: Array<PeFormInstanceQuestionApiModel | PeFormInstanceQuestionHeadingApiModel>;
  public MostAcceptablePerformanceCategories: Array<PeFormInstancePerformanceCategoryApiModel>;
  public LeastAcceptablePerformanceCategories: Array<PeFormInstancePerformanceCategoryApiModel>;
  public Ratings: Array<FormInstanceRatingApiModel>;
  public History: Array<PeFormInstanceWorkflowHistoryRecordApiModel>;
  public BoundFormInstances: PpBoundFormInstanceApiModel[];
  public Trainers: string[];
  public Shifts: string[];
  public RequireWorkflowComment: boolean;
  public RequireNextUserSelection: boolean;
  public Locations: string[];

  public deserialize(data: object): this {
    Object.assign(this, data);

    this.WorkDate = new Date(this.WorkDate);
    this.MinDate = new Date(this.MinDate);
    this.MaxDate = new Date(this.MaxDate);

    this.BoundFormInstances = this.BoundFormInstances.map((x) => new PpBoundFormInstanceApiModel().deserialize(x));

    return this;
  }
}
